import { Link } from "@tanstack/react-router";
import { LazyLoadImage } from "react-lazy-load-image-component";
import TextFragment from "../../ui/textFragment";
import colorfulshapeLeftTop from "@/assets/home/colorfulShapeLeftTop.png";
import colorfulshapeRightTop from "@/assets/home/colorfulShapeRightTop.png";
import colorfulshapeLeftBottom from "@/assets/home/colorfulShapeLeftBottom.png";
import colorfulshapeRightBottom from "@/assets/home/colorfulShapeRightBottom.png";
import arrowTile from "@/assets/home/tile_arrow.png";
import "./TilesDivision4_NewVisual.scss";

export const TilesDivisionInto4_NewVisual = (): JSX.Element => {
	return (
		<>
			<TextFragment as="h2" className="text-text1 mt-5 mb-3" variant="title">
				W Akademii LTCA:
			</TextFragment>
			<div className="flex gap-1.5 mb-4">
				<div className="flex flex-col justify-between gap-1.5 w-1/2">
					<Link
						className="h-1/2 aspect-square md:aspect-auto"
						to="/workshops/$type"
						params={{ type: "training" }}
						search={{ search: "", category: "", viewStatus: "UPCOMING" }}
					>
						<div className="relative min-h-[119px] md:min-h-[200px] h-full bg-homeTileTop rounded-xl overflow-hidden">
							<LazyLoadImage
								alt="phone left top"
								className="h-full"
								effect="blur"
								src={colorfulshapeLeftTop}
								wrapperProps={{
									className: "tile-image-height",
									style: {
										position: "absolute",
										bottom: 0,
										right: 0,
									},
								}}
							/>
							<div className="absolute top-0 left-0 w-full md:px-8 md:py-5 px-4 py-4 flex justify-start items-center">
								<TextFragment
									as="h3"
									className="text-white font-medium mr-3"
									variant="tile"
								>
									Szkolenia
								</TextFragment>
								<img src={arrowTile} alt="arrow" />
							</div>
						</div>
					</Link>
					<Link className="h-1/2 aspect-square md:aspect-auto" to="/courses">
						<div className="relative min-h-[119px] md:min-h-[200px] h-full bg-homeTileBottom rounded-xl overflow-hidden">
							<LazyLoadImage
								alt="phone left top"
								className="h-full"
								effect="blur"
								src={colorfulshapeLeftBottom}
								wrapperProps={{
									className: "tile-image-height",
									style: {
										float: "right",
									},
								}}
							/>
							<div className="absolute bottom-0 left-0 w-full md:px-8 md:py-5 px-4 py-4 flex justify-start items-center">
								<TextFragment
									as="h3"
									className="text-white font-medium mr-3"
									variant="tile"
								>
									Kursy
								</TextFragment>
								<img src={arrowTile} alt="arrow" />
							</div>
						</div>
					</Link>
				</div>
				<div className="flex flex-col gap-1.5 w-1/2">
					<Link
						className="h-1/2 aspect-square md:aspect-auto"
						to="/workshops/$type"
						params={{ type: "webinar" }}
						search={{ search: "", category: "", viewStatus: "UPCOMING" }}
					>
						<div className="relative min-h-[119px] md:min-h-[200px] h-full bg-homeTileTop rounded-xl overflow-hidden">
							<LazyLoadImage
								alt="phone left top"
								className="h-full"
								effect="blur"
								src={colorfulshapeRightTop}
								wrapperProps={{
									className: "tile-image-height",
									style: {
										position: "absolute",
										bottom: 0,
										left: 0,
									},
								}}
							/>
							<div className="absolute top-0 right-0 w-full md:px-8 md:py-5 px-4 py-4 flex justify-end items-center">
								<TextFragment
									as="h3"
									className="text-white font-medium mr-3"
									variant="tile"
								>
									Webinary
								</TextFragment>
								<img src={arrowTile} alt="arrow" />
							</div>
						</div>
					</Link>
					<Link className="h-1/2 aspect-square md:aspect-auto" to="/articles" search={{ category: 930 }}>
						<div className="relative min-h-[119px] md:min-h-[200px] h-full bg-homeTileBottom bg-right rounded-xl overflow-hidden">
							<LazyLoadImage
								alt="phone left top"
								className="h-full"
								effect="blur"
								src={colorfulshapeRightBottom}
								wrapperProps={{
									className: "tile-image-height",
									style: {
										float: "left",
									},
								}}
							/>
							<div className="absolute bottom-0 right-0 w-full md:px-8 md:py-5 px-4 py-4 flex justify-end items-center">
								<TextFragment
									as="h3"
									className="text-white font-medium mr-3"
									variant="tile"
								>
									Podcast
								</TextFragment>
								<img src={arrowTile} alt="arrow" />
							</div>
						</div>
					</Link>
				</div>
			</div>
		</>
	);
};
